module.exports = __webpack_public_path__ + "static/images/leaflet/marker-shadow.png";